import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRotateLeft } from '@fortawesome/free-solid-svg-icons';
import Question from './Question';

const levels = {
    'elementary': 'Elementary',
    'high_school': 'High School',
    'honors': 'Honors',
    'university': 'University',
};

const RecreateQuiz = (({ quiz, setShowQuiz }) => {
    console.log(quiz)

    return (
    <div className="modal-overlay">
        <div className="quiz-box">
            <h2>{`${quiz.topic} - ${levels[quiz.level]}`}</h2>
            <h4>{`Completed on: ${new Date(quiz.date_completed).toLocaleDateString()}`}</h4>
            {quiz?.questions?.map((question, index) => (
                <div key={`question-${index}`}>
                    <Question 
                        question={question}
                        index={index}
                        active={false}
                        showAnswers={true} 
                        showCheck={quiz.graded && question.correct}
                        showX={quiz.graded && !question.correct}
                    />
                </div>
            ))}

            <div className="group-btns-quiz">
                <Button className="quiz-btn" onClick={() => setShowQuiz(false)}>
                    <FontAwesomeIcon icon={faRotateLeft} className="me-2"/> 
                    Go Back
                </Button>
            </div>
        </div>
    </div>
    );
})

export default RecreateQuiz